export default {
	"910a489987588a1ec9cb2d7d5853623e": "Failed to redirect to customer service",
	"5fc753291f72817ee4b079ed2794b172": "Modify the result",
	"b939f06d6080b749c5d06676b16fb1ec": "Contact customer service",
	"a32c4611f33d31a6bf05278a0ba30489": "Got it"
}
